@if (dataLoading) {
  <div><ngx-skeleton-loader appearance="line" count="6"></ngx-skeleton-loader></div>
} @else if (isEndpointAvailable) {
  @if (accessTypeEndpoints?.length > 0) {
    <div class="endpoints-container mt-20 m-2 p-8">
      <div class="pt-16 pl-20 fs-18 fw-700">
        {{ 'INSTANCE_DETAILS.UI_ENDPOINTS' | transloco }}
      </div>

      <div class="flex flex-row endpoints-header items-center mt-20 mb-6 ml-16 mr-16 h-32 fs-12 fw-700">
        <div class="name-section pl-16">{{ 'INSTANCE_DETAILS.ENDPOINTS' | transloco | uppercase }}</div>
        <div>{{ 'INSTANCE_DETAILS.DESCRIPTION' | transloco | uppercase }}</div>
      </div>

      <div class="flex flex-col row-content ml-16 mr-16">
        @for (accessTypeEndpoint of accessTypeEndpoints; track accessTypeEndpoint) {
          <div class="flex endpoint-row items-center pt-8 pb-8">
            <div class="flex name-section">
              <div class="flex items-center endpoint-name p-6">
                <mat-icon
                  svgIcon="open_in_new"
                  class="icon-md mr-10 cursor-pointer"
                  (click)="navigateToUrl(accessTypeEndpoint?.url)">
                </mat-icon>
                <a class="mat-body cursor-pointer fw-600 fs-16"
                   [href]="accessTypeEndpoint?.url" target="_blank">
                   {{ accessTypeEndpoint?.name }}
                </a>
                @if (accessTypeEndpoint?.name) {
                  <mat-icon
                    [ngClass]="[copy ? 'copied': 'copy']"
                    [svgIcon]="copy ? 'check' : 'content_copy'"
                    class="copy-icon icon-sm cursor-pointer ml-10"
                    (click)="onCopy(accessTypeEndpoint?.url)">
                  </mat-icon>
                }
              </div>
            </div>
            <div class="description" [title]="accessTypeEndpoint?.description">
              {{ accessTypeEndpoint?.description || ('BLUEPRINT_SUMMARY.NA' | transloco) }}
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (exploreTypeEndpoints?.length > 0) {
    <div class="endpoints-container mt-20 m-2 p-8">
      <div class="pt-16 pl-20 fs-18 fw-700">{{ 'INSTANCE_DETAILS.API_ENDPOINTS' | transloco }}</div>
      <div class="flex flex-row endpoints-header items-center mt-20 mb-6 ml-16 mr-16 h-32 fs-12 fw-700">
        <div class="name-section pl-16">{{ 'INSTANCE_DETAILS.ENDPOINTS' | transloco | uppercase }}</div>
        <div>{{ 'INSTANCE_DETAILS.DESCRIPTION' | transloco | uppercase }}</div>
      </div>
      <div class="flex flex-col row-content ml-16 mr-16">
        @for (exploreTypeEndpoint of exploreTypeEndpoints; track exploreTypeEndpoint) {
          <div class="flex endpoint-row items-center pt-8 pb-8">
            <div class="flex name-section">
              <div class="flex items-center endpoint-name p-6">
                <mat-icon svgIcon="open_in_new" class="icon-md mr-10 cursor-pointer" (click)="navigateToUrl(exploreTypeEndpoint?.url)"></mat-icon>
                <a class="mat-body cursor-pointer fw-600 fs-16" [href]="exploreTypeEndpoint?.url" target="_blank">
                  {{ exploreTypeEndpoint?.name }}
                </a>
                @if (exploreTypeEndpoint?.name) {
                  <mat-icon
                    [ngClass]="[copy ? 'copied': 'copy']"
                    [svgIcon]="copy ? 'check' : 'content_copy'"
                    class="copy-icon icon-sm cursor-pointer ml-10"
                    (click)="onCopy(exploreTypeEndpoint?.url)">
                  </mat-icon>
                }
              </div>
            </div>
            <div class="description" [title]="exploreTypeEndpoint?.description">
              {{ exploreTypeEndpoint?.description || ('BLUEPRINT_SUMMARY.NA' | transloco) }}
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (configTypeEndpoints?.length > 0) {
    <div class="endpoints-container mt-20 m-2 p-8">
      <div class="pt-16 pl-20 fs-18 fw-700">{{ 'INSTANCE_DETAILS.CONFIGURATION' | transloco }}</div>
      <div class="flex flex-row endpoints-header items-center mt-20 mb-6 ml-16 mr-16 h-32 fs-12 fw-700">
        <div class="name-section pl-16">{{ 'INSTANCE_DETAILS.ENDPOINTS' | transloco | uppercase }}</div>
        <div>{{ 'INSTANCE_DETAILS.DESCRIPTION' | transloco | uppercase }}</div>
      </div>
      <div class="flex flex-col row-content ml-16 mr-16">
        @for (configTypeEndpoint of configTypeEndpoints; track configTypeEndpoint) {
          <div class="flex endpoint-row items-center pt-8 pb-8">
            <div class="flex name-section">
              <div class="flex items-center endpoint-name p-6">
                <mat-icon svgIcon="open_in_new" class="icon-md mr-10 cursor-pointer" (click)="navigateToUrl(configTypeEndpoint?.url)"></mat-icon>
                <a class="mat-body cursor-pointer fw-600 fs-16" [href]="configTypeEndpoint?.url" target="_blank">
                  {{ configTypeEndpoint?.name }}
                </a>
                @if (configTypeEndpoint?.name) {
                  <mat-icon
                    [ngClass]="[copy ? 'copied': 'copy']"
                    [svgIcon]="copy ? 'check' : 'content_copy'"
                    class="copy-icon icon-sm cursor-pointer ml-10"
                    (click)="onCopy(configTypeEndpoint?.url)">
                  </mat-icon>
                }
              </div>
            </div>
            <div class="description" [title]="configTypeEndpoint?.description">
              {{ configTypeEndpoint?.description || ('BLUEPRINT_SUMMARY.NA' | transloco) }}
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (otherTypeEndpoints?.length > 0) {
    <div class="endpoints-container mt-20 m-2 p-8">
      <div class="pt-16 pl-20 fs-18 fw-700">{{ 'INSTANCE_DETAILS.OTHER' | transloco }}</div>
      <div class="flex flex-row endpoints-header items-center mt-20 mb-6 ml-16 mr-16 h-32 fs-12 fw-700">
        <div class="name-section pl-16">{{ 'INSTANCE_DETAILS.ENDPOINTS' | transloco | uppercase }}</div>
        <div>{{ 'INSTANCE_DETAILS.DESCRIPTION' | transloco | uppercase }}</div>
      </div>
      <div class="flex flex-col row-content ml-16 mr-16">
        @for (otherTypeEndpoint of otherTypeEndpoints; track otherTypeEndpoint) {
          <div class="flex endpoint-row items-center pt-8 pb-8">
            <div class="flex name-section">
              <div class="flex items-center endpoint-name p-6">
                <mat-icon svgIcon="open_in_new" class="icon-md mr-10 cursor-pointer" (click)="navigateToUrl(otherTypeEndpoint?.url)"></mat-icon>
                <a class="mat-body cursor-pointer fw-600 fs-16" [href]="otherTypeEndpoint?.url" target="_blank">
                  {{ otherTypeEndpoint?.name }}
                </a>
                @if (otherTypeEndpoint?.name) {
                  <mat-icon
                    [ngClass]="[copy ? 'copied': 'copy']"
                    [svgIcon]="copy ? 'check' : 'content_copy'"
                    class="copy-icon icon-sm cursor-pointer ml-10"
                    (click)="onCopy(otherTypeEndpoint?.url)">
                  </mat-icon>
                }
              </div>
            </div>
            <div class="description" [title]="otherTypeEndpoint?.description">
              {{ otherTypeEndpoint?.description || ('BLUEPRINT_SUMMARY.NA' | transloco) }}
            </div>
          </div>
        }
      </div>
    </div>
  }
} @else {
  <div class="flex flex-col justify-center items-center mt-150">
    <mat-icon svgIcon="warning_amber" class="icon-warn"></mat-icon>
    <h2><span class="mt-10">{{ 'INSTANCE_LIST.ENDPOINTS_NOT_AVALIABLE' | transloco }}</span></h2>
  </div>
}
